import React, { useEffect } from "react";
import { motion } from "framer-motion";

export const TentangKami = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-cyan-600 flex-col justify-center relative bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-base sm:text-lg md:text-xl font-normal uppercase mb-1 md:mb-2 text-cyan-600"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          PT CAKRAWALA JAKARTA KREATIF
        </motion.h2>

        <motion.p
          className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mx-auto mb-8 md:mb-16 text-cyan-600 px-4"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          TENTANG KAMI
        </motion.p>

        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-cyan-900 mb-4">
                Company Profile
              </h3>
              <div className="text-lg text-cyan-800 space-y-6">
                <p>
                  Welcome to PT Cakrawala Jakarta Kreatif, a creative entity
                  that is legally incorporated and committed to providing
                  innovative solutions to encourage the development of
                  creativity and potential in Jakarta. We are not just a
                  collaboration platform, but an ecosystem that presents a
                  comprehensive experience in the world of art, culture, and
                  creative activities.
                </p>

                <p>
                  Through the services we provide, people can easily find,
                  participate in, and be involved in various inspiring
                  activities, ranging from art exhibitions, cultural festivals,
                  to workshops and seminars. The entire process is designed to
                  provide ease, security, and comfort in every step, to create a
                  meaningful experience.
                </p>

                <p>
                  Not only becoming a space for event registration, this
                  platform also becomes a place for creative actors to share
                  ideas, display works, and build collaboration networks. We
                  believe creativity grows through interaction, openness, and
                  real contribution in the community.
                </p>

                <p>
                  Make every creative moment more meaningful with us. Join
                  thousands of individuals and communities who have entrusted
                  their journey of developing their potential and work here.
                  Let's step together towards a world of limitless creativity.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
